import React from 'react';
import {ReactComponent as SecureIcon} from '../../assests/svg/secureIcon.svg';
import {useTranslation} from 'react-i18next';
import {Box, Typography} from '@mui/material';

const SecurePage: React.FC = () => {
  const {t} = useTranslation();
  return (
    <header className="secure-header">
      <SecureIcon />
      <Box className="secure-text-container">
        <Typography className="typo-text display2_size">
          {t('securePage.title')}
        </Typography>
        <Typography className="typo-text body1_size secure-description">
          {t('securePage.description')}
        </Typography>
      </Box>
      <Typography className="typo-text body3_size secure-error-code">
        {t('securePage.errorCode')}
      </Typography>
    </header>
  );
};

export {SecurePage};
